import { PARKING_FLOW_TYPE } from '~/utilities/constants'
import googleAnalytics from './googleAnalytics'
import googleConversion from './googleConversion'
import { pushMicrosoftConversion, microsoftConversions } from './microsoftConversion'
import * as paynycParking from './paynycParking'
import * as trafficLookup from './trafficLookup'
import { initTrackhome, identifyUser } from './trackhome'
export { initTrackhome, identifyUser }

// New Names
const CATEGORIES = {
  auth: 'Authentication',
  payment: 'Payment',
  traffic: {
    submission: 'Traffic Submission',
    fetcher: 'Traffic Fetcher'
  },
  divorce: {
    fetcher: 'Divorce Fetcher'
  },
  insurance: 'Insurance',
  parking: {
    ...PARKING_FLOW_TYPE
  },
  plate: 'Plate'
}

const AuthSignIn = provider => () => {
  googleAnalytics.event({
    category: CATEGORIES.auth,
    action: 'Login',
    label: provider
  })
}

const TRACKING_EVENTS = {
  general: {
    pageView: url => {
      googleAnalytics.pageview(url)
    },
    auth: {
      signup: () => {
        // facebookAnalytics.event('fb_mobile_complete_registration')
        googleConversion.general.signup()
        googleAnalytics.event({
          category: CATEGORIES.auth,
          action: 'sign up'
        })
        pushMicrosoftConversion(microsoftConversions.general.signup)
      },
      google: AuthSignIn('Google'),
      facebook: AuthSignIn('Facebook'),
      winit: AuthSignIn('WinIt'),
      resetPassword: () => {
        googleAnalytics.event({
          category: CATEGORIES.auth,
          action: 'Reset Password'
        })
      }
    }
  },
  payment: {
    updatePaymentMethod: () => {
      googleConversion.payments.addPaymentMethod()
      googleAnalytics.event({
        category: CATEGORIES.payment,
        action: 'Update Payment Method'
      })
      pushMicrosoftConversion(microsoftConversions.payments.addPaymentMethod)
    },
    updateBillingAddress: () => {
      googleAnalytics.event({
        category: CATEGORIES.payment,
        action: 'Update Billing Address'
      })
    }
  },
  insurance: {
    viewed: {
      processingScreen: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Processing Screen',
          nonInteractive: true
        })
      },
      invalidCredentialsScreen: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Invalid Credentials Screen',
          nonInteractive: true
        })
      },
      noQuotesAvailable: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View No Quotes Available Screen',
          nonInteractive: true
        })
      },
      quotesAvailable: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Quotes Available Screen',
          nonInteractive: true
        })
      },
      viewQuoteDetails: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Quotes Details',
          nonInteractive: true
        })
      },
      welcomeModal: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Welcome Modal',
          nonInteractive: true
        })
      },
      contactPage: () => {
        googleAnalytics.event({
          category: CATEGORIES.insurance,
          action: 'View Contact Page',
          nonInteractive: true
        })
      }
    },
    saveMoneyOnQuote: () => {
      googleAnalytics.event({
        category: CATEGORIES.insurance,
        action: 'Available Quotes - Pressed Save Money'
      })
    },
    welcomeModalStartNow: () => {
      googleAnalytics.event({
        category: CATEGORIES.insurance,
        action: 'Welcome Modal - Pressed Start Now'
      })
    },
    welcomeModalDownArrow: () => {
      googleAnalytics.event({
        category: CATEGORIES.insurance,
        action: 'Welcome Modal - Pressed Down Arrow'
      })
    },
    selectedInsurance: company => {
      googleAnalytics.event({
        category: CATEGORIES.insurance,
        action: 'Selected Insurance Provider',
        label: company
      })
    },
    collected: company => {
      googleAnalytics.event({
        category: CATEGORIES.insurance,
        action: 'Submission Completed',
        label: company
      })
    }
  },
  parking: {
    submissionConversion: (transactionId, entryType, currentHost) => {
      const action = `Parking Submission - ${entryType}`
      switch(entryType) {
        case PARKING_FLOW_TYPE.fight:
          googleConversion.parking.fightFlow.submissionCompleted(transactionId)
          pushMicrosoftConversion(microsoftConversions.parking.fightFlow.submissionCompleted)
          googleAnalytics.event({
            category: CATEGORIES.parking[entryType],
            action,
            value: 5
          })
          break
        case PARKING_FLOW_TYPE.pay:
          if(currentHost.includes('paynyctickets.com')){
            googleConversion.parking.payFlowNYC.submissionCompleted(transactionId)
            pushMicrosoftConversion(microsoftConversions.parking.payFlowNYC.submissionCompleted)
          } else {
            googleConversion.parking.payFlow.submissionCompleted(transactionId)
            pushMicrosoftConversion(microsoftConversions.parking.payFlow.submissionCompleted)
          }
          googleAnalytics.event({
            category: CATEGORIES.parking[entryType],
            action,
            value: 3
          })
          break
        case PARKING_FLOW_TYPE.both:
          googleConversion.parking.payAndFlow.submissionCompleted(transactionId)
          googleAnalytics.event({
            category: CATEGORIES.parking[entryType],
            action
          })
          break
        default:
      }
    },
    fetcherResults: (entryType, currentHost) => {
      const action = `Parking View Results - ${entryType}`
      switch(entryType) {
        case PARKING_FLOW_TYPE.pay:
          if (currentHost.includes('paynyctickets.com')) {
            googleConversion.parking.payFlowNYC.resultsPage()
          }
          googleAnalytics.event({
            category: CATEGORIES.parking[entryType],
            action,
            value: 3
          })
          break
        default:
      }
    },
    arrivedFromNycEmail: (entryType, origin) => {
      googleAnalytics.event({
        category: CATEGORIES.parking[entryType],
        action: `Arrived from NYC Email - ${origin}`
      })
    },
    paidFromNycEmail: (entryType, origin) => {
      googleAnalytics.event({
        category: CATEGORIES.parking[entryType],
        action: `Paid from NYC Email - ${origin}`
      })
    },
  },
  paynycParking,
  trafficLookup,
  identifyUser,
  plate: {
    plateCreated: () => {
      googleConversion.plate.plateCreated(false)
      googleAnalytics.event({
        category: CATEGORIES.plate,
        action: 'Created'
      })
      pushMicrosoftConversion(microsoftConversions.plate.plateCreated)
    }
  },
  traffic: {
    clickedPhoneNumber: () => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Clicked Phone Number'
      })
    },
    stateSelector: () => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: '0.state-selector',
      })
    },
    submissionConversion: (transactionId, source) => {
      let action = 'Submission Completed'
      if (source) {
        action = `${action} - ${source}`
      }
      if (source === 'traffic flow') {
        googleConversion.traffic.manualFlow.submissionCompleted(transactionId)
        pushMicrosoftConversion(microsoftConversions.traffic.manualFlow.submissionCompleted)
      }
      if (source === 'fetcher') {
        googleConversion.traffic.fetcherFlow.submissionCompleted(transactionId)
        pushMicrosoftConversion(microsoftConversions.traffic.fetcherFlow.submissionCompleted)
      }
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action,
        value:70
      })
      // facebookAnalytics.event('fb_mobile_spent_credit') // our legacy event name for completed traffic submission
    },
    pendingConf: (transactionId) => {
      googleConversion.traffic.manualFlow.pendingConf(transactionId)
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Ticket Pending Conf',
        value: 3
      })
      pushMicrosoftConversion(microsoftConversions.traffic.manualFlow.pendingConf)
    },
    firstPersist: () => {
      googleConversion.traffic.manualFlow.temp(false)
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Ticket Persisted',
        value: 1
      })
      pushMicrosoftConversion(microsoftConversions.traffic.manualFlow.temp)
    },
    trackCurrentStep: stepName => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Step',
        label: stepName
      })
    },
    checkoutFAQButton: () => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Clicked Checkout FAQ Button'
      })
    },
    viewAttorneyInfoModal: () => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Viewed Attorney Info Modal'
      })
    },
    clickedFAQQuestion: question => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.submission,
        action: 'Clicked FAQ Question',
        label: question
      })
    },
    fightMyTicket: nextStep => {
      googleAnalytics.event({
        category: CATEGORIES.traffic.fetcher,
        action: `Fight My Ticket - ${nextStep}`
      })
    },
    /**
     * Multi-step in-page lookup wizards only (e.g. NY DMV 3-step form).
     * Do not call from single-screen lookup routes (results, checkout, etc.).
     * GA event_label = fetcher|state|step.
     */
    lookupStepView: ({ fetcherName, state, step }) => {
      const fetcher = fetcherName || 'unknown'
      const statePart =
        state != null && String(state) !== '' ? String(state) : 'unknown'
      googleAnalytics.event({
        category: CATEGORIES.traffic.fetcher,
        action: 'Lookup Step View',
        label: `${fetcher}|${statePart}|${step}`,
        value: typeof step === 'number' ? step : undefined
      })
    },
    fetcherInfoAdded: (fetcherName) => {
      googleConversion.traffic.fetcherFlow.informationAdded(fetcherName)
      pushMicrosoftConversion(microsoftConversions.traffic.fetcherFlow.informationAdded)
    },
    fetcherResultsTiming: (type, fetcherName) => {
      return googleAnalytics.timingBuilder({
        category: CATEGORIES.traffic.fetcher,
        name: 'Fetcher Search Time',
        onStart: () => {
          googleAnalytics.event({
            category: CATEGORIES.traffic.fetcher,
            action: `Search - ${type}`,
            value: 1
          })
        }
      })
    },
    fetcherResults: (fetcherName) => {
      googleConversion.traffic.fetcherFlow.resultsPage(fetcherName)
      pushMicrosoftConversion(microsoftConversions.traffic.fetcherFlow.resultsPage)
      googleAnalytics.event({
        category: CATEGORIES.traffic.fetcher,
        action: 'View Results',
        value : 3
      })
    },
    fetcherNoResults: (fetcherName) => {
      googleConversion.traffic.fetcherFlow.noResultsPage(fetcherName)
      googleAnalytics.event({
        category: CATEGORIES.traffic.fetcher,
        action: 'No Results'
      })
    }
  },
  divorce: {
    fetcherResultsTiming: (type, fetcherName) => {
      return googleAnalytics.timingBuilder({
        category: CATEGORIES.divorce.fetcher,
        name: 'Fetcher Search Time',
        onStart: () => {
          googleAnalytics.event({
            category: CATEGORIES.divorce.fetcher,
            action: `Search - ${type}`,
            value: 1
          })
          googleConversion.divorce.fetcherFlow.informationAdded(fetcherName)
          pushMicrosoftConversion(microsoftConversions.divorce.fetcherFlow.informationAdded)
        }
      })
    },
    fetcherResults: (fetcherName) => {
      googleConversion.divorce.fetcherFlow.resultsPage(fetcherName)
      pushMicrosoftConversion(microsoftConversions.divorce.fetcherFlow.resultsPage)
      googleAnalytics.event({
        category: CATEGORIES.divorce.fetcher,
        action: 'View Results',
        value : 3
      })
    },
  }
}

export default TRACKING_EVENTS
